import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useLang } from "@/i18n";
import { homeQueryKey, fetchHome } from "@/lib/queries";
import { cldUrl } from "@/lib/img";


export default function Hero() {
  const { lang, t } = useLang();
  // Shares a cache entry (and, when mounted together, a single network
  // request) with BenefitMarquee, ShopByCategory, ProductTabs and
  // Storytelling -- see lib/queries.js.
  const { data } = useQuery({ queryKey: homeQueryKey, queryFn: fetchHome });
  const c = data?.content;

  const heroImg = cldUrl(c?.hero_image, { w: 1920 }) || "https://customer-assets-eiarnc6j.emergentagent.net/job_kreyola-boutik/artifacts/pdh3b8ei_REAL%20sunsetpalm-tree.webp";
  const subtitle = c?.[`hero_subtitle_${lang}`] || "";
  const supporting = c?.[`hero_supporting_${lang}`] || "";

  return (
    <section className="relative min-h-[88vh] w-full overflow-hidden" data-testid="hero-section">
      <img src={heroImg} alt="Haitian sunset — Lakay" fetchpriority="high" className="absolute inset-0 h-full w-full object-cover object-[62%_center] sm:object-center" />
      <div className="hero-overlay absolute inset-0" />

      <div className="relative mx-auto flex min-h-[88vh] max-w-[1400px] flex-col items-center justify-center px-4 py-20 text-center">
        <p className="mb-4 rounded-full bg-navy/40 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.3em] text-gold backdrop-blur-sm animate-fade-up [text-shadow:_0_2px_8px_rgba(11,25,44,0.8)]" style={{ animationDelay: ".1s" }}>
          {supporting}
        </p>

        <h1 className="max-w-4xl font-script text-4xl leading-tight text-cream drop-shadow-lg animate-fade-up sm:text-6xl lg:text-7xl" style={{ animationDelay: ".2s" }}>
          {c?.hero_slogan || "Nou pote gou manje lakay nan plat ou"}
        </h1>

        <p className="mt-6 max-w-2xl text-base text-cream/90 drop-shadow animate-fade-up sm:text-lg" style={{ animationDelay: ".35s" }}>
          {subtitle}
        </p>

        <div className="mt-9 flex flex-col items-center gap-3 animate-fade-up sm:flex-row" style={{ animationDelay: ".5s" }}>
          <Link to="/shop" data-testid="hero-shop-cta-btn" className="btn-gold w-64 rounded-full px-8 py-4 text-sm font-bold uppercase tracking-wider sm:w-auto">
            {c?.[`hero_cta_primary_${lang}`] || t("common.shopNow")} →
          </Link>
        </div>
      </div>
    </section>
  );
}
